import { render, staticRenderFns } from "./ProformaCalculator.vue?vue&type=template&id=a0256446&"
import script from "./ProformaCalculator.vue?vue&type=script&lang=ts&"
export * from "./ProformaCalculator.vue?vue&type=script&lang=ts&"
import style0 from "./ProformaCalculator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports